import type { IconData } from '@stacksjs/iconify-core'

export const levelUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M80 384v32h216V78.627l84.687 84.687l22.626-22.628L280 17.373L156.687 140.686l22.626 22.628L264 78.627V384z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default levelUp
